const Switch = ({ checked, onChange, disabled = false }) => (
    <button
        type="button"
        role="switch"
        aria-checked={checked}
        disabled={disabled}
        onClick={() => onChange(!checked)}
        className={`relative inline-flex h-5 w-9 shrink-0 items-center rounded-full transition-colors ${
            checked ? "bg-indigo-600" : "bg-zinc-700"
        } ${disabled ? "opacity-60 cursor-not-allowed" : "cursor-pointer"}`}
    >
        <span
            className={`inline-block h-4 w-4 rounded-full bg-white shadow transition-transform ${
                checked ? "translate-x-[18px]" : "translate-x-0.5"
            }`}
        />
    </button>
);

export default Switch;
